export const createExperience = ({ BeURL, experience, setExperiences, }) => {

    fetch(`${BeURL}/candidate-experience`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ experience }),
    })
        .then(res => res.json())
        .then(data => {
            alert(data.message);
            if (data.success) {
                setExperiences(prev => ([...prev, experience[0]]))
                window.location.reload()

            }
        })
        .catch(err => console.log("Error in Adding Experience", err));
}
